import { render, staticRenderFns } from "./CustomerStore.vue?vue&type=template&id=3414b93b&"
import script from "./CustomerStore.vue?vue&type=script&lang=js&"
export * from "./CustomerStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports